export default {
    children: [],
    selectedChild: {},
    loading: false
};
